"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _faCircleNotch = require("@fortawesome/fontawesome-free-solid/faCircleNotch");

var _faCircleNotch2 = _interopRequireDefault(_faCircleNotch);

var _faSave = require("@fortawesome/fontawesome-free-solid/faSave");

var _faSave2 = _interopRequireDefault(_faSave);

var _buttonSubmit = require("./buttonSubmit");

var _buttonSubmit2 = _interopRequireDefault(_buttonSubmit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SaveButton = function SaveButton(props) {
    return _react2.default.createElement(_buttonSubmit2.default, _extends({
        submitting: props.saving,
        icon: _react2.default.createElement(_reactFontawesome2.default, { icon: _faSave2.default }),
        submittingIcon: _react2.default.createElement(_reactFontawesome2.default, { icon: _faCircleNotch2.default, spin: true })
    }, props));
};

SaveButton.displayName = "SaveButton";

SaveButton.propTypes = {
    saving: _propTypes2.default.bool,
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
};

SaveButton.defaultProps = {
    saving: false,
    label: "Save"
};

exports.default = SaveButton;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/buttonSave.js
// module id = 991
// module chunks = 95715928098905 168707334958949